// Alternative simple toggle button version
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';

export const LanguageToggle: FunctionComponent = () => {
    const { i18n } = useTranslation();
    const currentLanguage = i18n.language || 'de';

    const toggleLanguage = async () => {
        const newLanguage = currentLanguage === 'de' ? 'en' : 'de';
        await i18n.changeLanguage(newLanguage);
    };

    return (
        <Button
            onClick={toggleLanguage}
            variant='outlined'
            size='small'
            startIcon={<LanguageIcon />}
        >
            {currentLanguage === 'de' ? 'EN' : 'DE'}
        </Button>
    );
};
